import { render, staticRenderFns } from "./appointList.vue?vue&type=template&id=83d4bda4&scoped=true&"
import script from "./appointList.vue?vue&type=script&lang=js&"
export * from "./appointList.vue?vue&type=script&lang=js&"
import style0 from "./appointList.vue?vue&type=style&index=0&id=83d4bda4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d4bda4",
  null
  
)

export default component.exports